export default __webpack_public_path__ + "static/media/information.2a0f008c.svg";